
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./shifts.css";

import Icon from "../../components/em/Icon";
import PropTypes from 'prop-types';
import { API_URL } from '../../api/api';




import { toast } from "../../utils/toast";
const auth = () => {
  const t = localStorage.getItem('token');
  return t ? { headers: { Authorization: `Bearer ${t}` } } : {};
};
const handleAuthError = (err) => {
  if (err?.response?.status === 401) {
    localStorage.clear();
    window.location.assign('/login');
    return true;
  }
  return false;
};

const BulkAssignModal = ({ shifts, onClose, onSuccess, defaultShiftId = "" }) => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [empSearch, setEmpSearch] = useState("");
  const [selectedEmps, setSelectedEmps] = useState(new Set());
  const [mode, setMode] = useState("department"); // "department" | "employees"

  const [form, setForm] = useState({
    department_id: "",
    shift_id: defaultShiftId ? String(defaultShiftId) : "",
    start_date: "",
    end_date: "",
    include_saturday: false,
    include_sunday: false
  });

  /* ---------------- FETCH DEPARTMENTS + EMPLOYEES ---------------- */
  useEffect(() => {
    axios
      .get(`${API_URL}/api/settings/departments`, auth())
      .then((res) => setDepartments(res.data))
      .catch((err) => {
        if (handleAuthError(err)) return;
        console.error('Department load error:', err);
      });
    axios
      .get(`${API_URL}/api/settings/shifts/team-members`, auth())
      .then((res) => setEmployees(res.data || []))
      .catch((err) => {
        if (handleAuthError(err)) return;
        console.error('Team members load error:', err);
      });
  }, []);

  /* ---------------- HANDLE CHANGE ---------------- */
  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  /* ---------------- SUBMIT ---------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();

    const hasDept = mode === "department" && form.department_id;
    const hasEmps = mode === "employees" && selectedEmps.size > 0;

    if ((!hasDept && !hasEmps) || !form.shift_id || !form.start_date || !form.end_date) {
      return toast.error("Please fill all required fields");
    }
    if (form.start_date > form.end_date) {
      return toast.error("Start date cannot be after End date");
    }

    try {
      setLoading(true);
      const payload = {
        ...form,
        department_id: mode === "department" ? form.department_id : undefined,
        employee_ids: mode === "employees" ? Array.from(selectedEmps) : undefined,
      };

      const res = await axios.post(
        `${API_URL}/api/settings/shifts/bulk-assign`,
        payload,
        auth()
      );
      if (res.data && res.data.success === false) {
        toast.error(res.data.message || 'Bulk assign failed');
        return;
      }
      toast.success('Shifts assigned successfully!');
      onSuccess();
      onClose();
    } catch (err) {
      if (handleAuthError(err)) return;
      console.error(err);
      toast.error(err?.response?.data?.message || err?.response?.data?.error || 'Bulk assign failed');
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- UI ---------------- */
  return (
    <div className="modal-overlay">

      <div className="modal">






<div className="title-btns">
  <div className="icn-subtit">
    <span className="icon-wrap">
      <Icon name="table" color="#0A0A0A" />
    </span>
    <h3>Bulk Assign Shifts</h3>
    <p>Assign a shift to all employees in a department for a date range.</p>
  </div>
  <div className="close-btn">
    <div className="clbtn" onClick={onClose}><Icon name="close" color="#f54b01" />
  </div>
  </div>
</div>






        <form onSubmit={handleSubmit}>

          {/* Mode toggle — by department or by individual employees */}
          <div className="bulk-mode-toggle">
            <button
              type="button"
              className={mode === "department" ? "is-on" : ""}
              onClick={() => setMode("department")}
            >
              By Department
            </button>
            <button
              type="button"
              className={mode === "employees" ? "is-on" : ""}
              onClick={() => setMode("employees")}
            >
              By Employees ({selectedEmps.size})
            </button>
          </div>

          {mode === "department" ? (
            <div className="form-item">
              <label>Department *</label>
              <select
                name="department_id"
                value={form.department_id}
                onChange={handleChange}
              >
                <option value="">Select Department</option>
                {departments.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.name}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <div className="form-item">
              <label>
                Employees * <small style={{ color: "#64748b", fontWeight: 400 }}>
                  ({selectedEmps.size} selected)
                </small>
              </label>
              <input
                type="text"
                placeholder="Search employees…"
                value={empSearch}
                onChange={(e) => setEmpSearch(e.target.value)}
                style={{ marginBottom: 6 }}
              />
              <div className="bulk-emp-list">
                {(() => {
                  const q = empSearch.trim().toLowerCase();
                  const visible = employees.filter((e) => {
                    if (!q) return true;
                    const full = `${e.first_name || ""} ${e.last_name || ""} ${e.designation || ""}`.toLowerCase();
                    return full.includes(q);
                  });
                  if (visible.length === 0) {
                    return <p className="muted">No employees found.</p>;
                  }
                  const allSelected =
                    visible.length > 0 &&
                    visible.every((e) => selectedEmps.has(e.id));
                  return (
                    <>
                      <label className="bulk-emp-row bulk-emp-all">
                        <input
                          type="checkbox"
                          checked={allSelected}
                          onChange={() => {
                            setSelectedEmps((prev) => {
                              const next = new Set(prev);
                              if (allSelected) visible.forEach((e) => next.delete(e.id));
                              else visible.forEach((e) => next.add(e.id));
                              return next;
                            });
                          }}
                        />
                        <b>
                          {allSelected ? "Deselect" : "Select"} all visible
                        </b>
                      </label>
                      {visible.map((e) => (
                        <label key={e.id} className="bulk-emp-row">
                          <input
                            type="checkbox"
                            checked={selectedEmps.has(e.id)}
                            onChange={() => {
                              setSelectedEmps((prev) => {
                                const next = new Set(prev);
                                if (next.has(e.id)) next.delete(e.id);
                                else next.add(e.id);
                                return next;
                              });
                            }}
                          />
                          <span>
                            {e.first_name} {e.last_name}
                            {e.designation ? (
                              <small> · {e.designation}</small>
                            ) : null}
                          </span>
                        </label>
                      ))}
                    </>
                  );
                })()}
              </div>
            </div>
          )}


<div className="form-item">
          <label>Shift *</label>
          <select
            name="shift_id"
            value={form.shift_id}
            onChange={handleChange}
          >
            <option value="">Select Shift</option>
            {shifts.map(s => (
              <option key={s.id} value={s.id}>
                {s.name} ({s.start_time} - {s.end_time})
              </option>
            ))}
          </select>
</div>

          {/* Date Range */}
          <div className="date-row col-2">

<div className="form-item">
              <label>Start Date *</label>
              <input
                type="date"
                name="start_date"
                value={form.start_date}
                onChange={handleChange}
              />
            </div>

     <div className="form-item">
              <label>End Date *</label>
              <input
                type="date"
                name="end_date"
                value={form.end_date}
                onChange={handleChange}
              />
            </div>

          </div>

          {/* Weekend Toggles */}

          <div className="form-item inc-wrap">
            <p><b>Include Weekends</b></p>
            <p><span>Include Saturday</span>
            <label className="ckbox">
              <input
              type="checkbox"
              name="include_saturday"
              checked={form.include_saturday}
              onChange={handleChange}
              />
              <i></i>
            </label>
          </p>
          <p><span>Include Sunday</span>
          <label className="ckbox">
            <input
            type="checkbox"
            name="include_sunday"
            checked={form.include_sunday}
            onChange={handleChange}
            />
            <i></i>
            
          </label>
          </p>
          </div>

          {/* Actions */}
          <div className="modal-actions">

            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="org-gradi"
              disabled={loading}
            >
              {loading ? "Assigning..." : "Bulk Assign"}
            </button>

          </div>

        </form>
      </div>
    </div>
  );
};

export default BulkAssignModal;
